export type TimerStatus = 'idle' | 'running' | 'paused' | 'stopped'
export type TimerMode = 'card' | 'fullscreen'

export interface TimerState {
  status: TimerStatus
  mode: TimerMode
  currentSessionId: string | null
  startTimestamp: number | null
  pauseTimestamp: number | null
  pauseDuration: number // acumulado de pausas em ms
  pauseStartTimestamp: number | null
  addedTime: number // tempo adicionado em segundos
  initialDuration: number // em segundos (da API)
  isVisible: boolean
}

export enum TimerActionTypes {
  START_TIMER = '@timer/START_TIMER',
  PAUSE_TIMER = '@timer/PAUSE_TIMER',
  RESUME_TIMER = '@timer/RESUME_TIMER',
  STOP_TIMER = '@timer/STOP_TIMER',
  RESET_TIMER = '@timer/RESET_TIMER',
  RESTART_TIMER = '@timer/RESTART_TIMER',
  ADD_TIME = '@timer/ADD_TIME',
  TOGGLE_MODE = '@timer/TOGGLE_MODE',
  SET_VISIBILITY = '@timer/SET_VISIBILITY',
}

export interface StartTimerAction {
  type: TimerActionTypes.START_TIMER
  payload: {
    sessionId: string
    duration: number // em segundos
  }
}

export interface PauseTimerAction {
  type: TimerActionTypes.PAUSE_TIMER
}

export interface ResumeTimerAction {
  type: TimerActionTypes.RESUME_TIMER
}

export interface StopTimerAction {
  type: TimerActionTypes.STOP_TIMER
}

export interface ResetTimerAction {
  type: TimerActionTypes.RESET_TIMER
}

export interface RestartTimerAction {
  type: TimerActionTypes.RESTART_TIMER
}

export interface AddTimeAction {
  type: TimerActionTypes.ADD_TIME
  payload: number // segundos
}

export interface ToggleModeAction {
  type: TimerActionTypes.TOGGLE_MODE
}

export interface SetVisibilityAction {
  type: TimerActionTypes.SET_VISIBILITY
  payload: boolean
}

export type TimerActions =
  | StartTimerAction
  | PauseTimerAction
  | ResumeTimerAction
  | StopTimerAction
  | ResetTimerAction
  | RestartTimerAction
  | AddTimeAction
  | ToggleModeAction
  | SetVisibilityAction
